import styled from 'styled-components'

import Dropdown from '../Dropdown/Container'
import Row from '../Row'

const LandingPageButtonGroup = styled(Row)`
  padding: ${props => props.theme.gutter}px;
  ${Dropdown} {
    flex: 0 0 calc(100% - 154px + ${props => props.theme.gutter * 1}px);
  }

  @media (max-width: 767.9px) {
    padding-top: 0;
  }

  @media (min-width: 768px) {
    ${Dropdown} {
      flex: 1;
    }
  }

  @media (min-width: 992px) {
    ${Dropdown} {
      flex: 0 0 300px;
    }
  }
`

export default LandingPageButtonGroup
